"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { WaveGroupType } from "../WaveGroup.types";
import WaveGroupRemove from "./WaveGroupRemove";
import type { ApiUpdateWaveRequest } from "@/generated/models/ApiUpdateWaveRequest";
export type WaveGroupRemoveButtonHandle = {
  open: () => void;
};
interface WaveGroupRemoveButtonProps {
  readonly wave: ApiWave;
  readonly type: WaveGroupType;
  readonly onWaveUpdate: (body: ApiUpdateWaveRequest, opts?: {
    readonly skipAuth?: boolean | undefined;
  }) => Promise<void>;
  readonly renderTrigger?: ((options: {
    readonly open: () => void;
  }) => ReactNode) | null | undefined;
}
const WaveGroupRemoveButton = forwardRef<WaveGroupRemoveButtonHandle, WaveGroupRemoveButtonProps>(function WaveGroupRemoveButton(t0, ref) {
  const $ = _c(16);
  const {
    wave,
    type,
    onWaveUpdate,
    renderTrigger
  } = t0;
  const [isEditOpen, setIsEditOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsEditOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleOpen = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => ({
      open: handleOpen
    });
    t3 = [handleOpen];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useImperativeHandle(ref, t2, t3);
  let t4;
  if ($[3] !== onWaveUpdate) {
    t4 = async body => {
      await onWaveUpdate(body);
      setIsEditOpen(false);
    };
    $[3] = onWaveUpdate;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleWaveUpdate = t4;
  let triggerContent;
  if (renderTrigger === null) {
    triggerContent = null;
  } else {
    if (renderTrigger) {
      let t5;
      if ($[5] !== renderTrigger) {
        t5 = renderTrigger({
          open: handleOpen
        });
        $[5] = renderTrigger;
        $[6] = t5;
      } else {
        t5 = $[6];
      }
      triggerContent = t5;
    } else {
      let t5;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <button type="button" aria-haspopup="dialog" aria-label="Remove" title="Remove" onClick={handleOpen} className="tw-border-none tw-bg-transparent tw-p-0 tw-flex tw-items-center"><FontAwesomeIcon icon={faCircleXmark} className="tw-flex-shrink-0 tw-size-5 tw-text-red tw-transition tw-duration-300 tw-ease-out hover:tw-scale-110" /></button>;
        $[7] = t5;
      } else {
        t5 = $[7];
      }
      triggerContent = t5;
    }
  }
  let t5;
  if ($[8] !== handleWaveUpdate || $[9] !== isEditOpen || $[10] !== type || $[11] !== wave) {
    t5 = <WaveGroupRemove wave={wave} isEditOpen={isEditOpen} type={type} setIsEditOpen={setIsEditOpen} onWaveUpdate={handleWaveUpdate} />;
    $[8] = handleWaveUpdate;
    $[9] = isEditOpen;
    $[10] = type;
    $[11] = wave;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5 || $[14] !== triggerContent) {
    t6 = <>{triggerContent}{t5}</>;
    $[13] = t5;
    $[14] = triggerContent;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
});
export default WaveGroupRemoveButton;